import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { navLinks } from '../data/site';
export function Navbar() {
  const [open, setOpen] = useState(false);
  return <header className="fixed inset-x-0 top-0 z-50 border-b border-stone bg-ivory/95 backdrop-blur" data-id="element-64" data-mp="x9dv1ja8s8n5">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-10" data-id="element-65" data-mp="sbcaetx6419k">
        <Link to="/" className="flex items-center gap-3" data-id="element-66" data-mp="4lqdkd49py4q">
          <span className="flex h-10 w-10 items-center justify-center bg-ink-950 font-display text-sm text-brass-300" data-id="element-67" data-mp="k4to7tbgjl1">
            AZ
          </span>
          <span className="font-display text-[15px] text-ink-950" data-id="element-68" data-mp="ekpch3z8efej">
            Andrew Zinkel
            <span className="ml-2 font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-brass-500" data-id="element-69" data-mp="9iqb1zn1xsk8">
              MD, MBA
            </span>
          </span>
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-7 xl:flex" data-id="element-70" data-mp="1kyoo0elcoyqq">
          {navLinks.map(link => <NavLink key={link.to} to={link.to} end={link.to === '/'} className={({
          isActive
        }) => `font-display text-[13px] tracking-wide transition-colors ${isActive ? 'text-ink-950 underline decoration-brass-500 decoration-2 underline-offset-[6px]' : 'text-graphite hover:text-ink-950'}`} data-id="element-71" data-mp="9o7vu2qvtknx">
              {link.label}
            </NavLink>)}
        </nav>

        <Link to="/contact" className="hidden bg-ink-950 px-5 py-3 font-display text-[12px] text-ivory transition-colors hover:bg-ink-800 xl:inline-block" data-id="element-72" data-mp="vmd2mn93dz3">
          Request Advisory
        </Link>

        <button type="button" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} onClick={() => setOpen(v => !v)} className="p-2 text-ink-950 xl:hidden" data-id="element-73" data-mp="34c37wk2g5of5">
          {open ? <XIcon size={22} data-id="element-74" data-mp="318x1l9awz7ao" /> : <MenuIcon size={22} data-id="element-75" data-mp="2wcgdgf3pssxl" />}
        </button>
      </div>

      {open && <nav aria-label="Mobile" className="border-t border-stone bg-ivory px-6 py-3 xl:hidden" data-id="element-76" data-mp="2wacbi2pdm3zy">
          <ul className="flex flex-col" data-id="element-77" data-mp="361ggqap92ahl">
            {navLinks.map(link => <li key={link.to} data-id="element-78" data-mp="2icfgvbuhg7nx">
                <NavLink to={link.to} end={link.to === '/'} onClick={() => setOpen(false)} className={({
            isActive
          }) => `block border-b border-stone py-3.5 font-display text-sm ${isActive ? 'text-brass-500' : 'text-ink-950'}`} data-id="element-79" data-mp="2idgpzarxuk30">
                  {link.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>}
    </header>;
}